import styled from "styled-components";

export const ClassworkPageGridContent = styled.div`
  width: 100%;

  max-width: 1300px;
  margin: 0 auto;

  grid-area: content;
  z-index: 1;

  padding: 0 1rem;
`;

export const ClassworkPageGridContainer = styled.section`
  display: grid;
  grid-template-areas: "content";
  align-items: start;

  background-color: ${({ theme }) => theme.classwork.backgroundColor};

  margin-top: 7rem;

  min-height: 100%;
  position: relative;

  li {
    list-style: none;
  }
`;
